<template>
  <v-card class="card-border">
    <v-card-text>
      <v-form>
        <v-row align="center">
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Inicio" @onChanged="dateStart = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Fim" @onChanged="dateEnd = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Gerente } from "@/services/dashboard";

export default {
  name: "Filtro",

  components: {
    DateMenu: () => import("@/components/datepicker/DateMenu")
  },

  data() {
    return {
      dateStart: null,
      dateEnd: null,
      serviceGerente: new Gerente()
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapGetters("dashboard", ["getRankLeads"]),
    ...mapGetters("dashboard", ["getRankNovos"]),
    ...mapGetters("dashboard", ["getRankUsados"]),
    ...mapGetters("dashboard", ["getRankConsorcio"])
  },

  methods: {
    ...mapActions("dashboard", ["setLeads"]),
    ...mapActions("dashboard", ["setRankLeads"]),
    ...mapActions("dashboard", ["setRankNovos"]),
    ...mapActions("dashboard", ["setRankUsados"]),
    ...mapActions("dashboard", ["setRankConsorcio"]),
    ...mapActions("dashboard", ["setHistoricoRank"]),

    async getRanks() {
      try {
        const rank = await this.serviceGerente.getRanks();
        this.setRankLeads([...rank]);
        this.setRankNovos([...rank]);
        this.setRankUsados([...rank]);
        this.setRankConsorcio([...rank]);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getHistoricoRanks() {
      try {
        const rank = await this.serviceGerente.getHistoricoRanks();
        this.setHistoricoRank([...rank]);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async buscar() {
      try {
        const response = await this.serviceGerente.getLeads(
          this.dateStart,
          this.dateEnd
        );
        this.setLeads(response);
      } catch (error) {
        this.$toast.error("Erro ao carregar Dados");
        return Promise.reject(error);
      }
    }
  },

  async mounted() {
    try {
      if (
        this.getRankUsados.length == 0 ||
        this.getRankNovos.length == 0 ||
        this.getRankLeads.length == 0 ||
        this.getRankConsorcio.length == 0
      ) {
        await this.getRanks();
        await this.getHistoricoRanks();
      }
      return Promise.resolve();
    } catch (error) {
      this.$toast.error("Erro ao carregar Dados");
      return Promise.reject(error);
    }
  }
};
</script>
